import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Struttura di consegna',
  subtitle: 'Scegli come vengono consegnati gli ordini (per sede).',
  form: {
    delivery_mode: {
      label: 'Modalità di consegna',
      placeholder: 'Seleziona modalità di consegna',
      options: {
        [DeliveryMode.Internal]: 'Interna (corrieri propri)',
        [DeliveryMode.External]: 'Esterna (terze parti)',
      },
    },
  },
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
    skip: 'Salta',
  },
  toasts: {
    error: 'Qualcosa è andato storto. Riprova.',
  },
};
